import React from "react";
import StudentTable from "./StudentTable";

const StudentTableProps = ({ studentList, isAutoEval }) => {
  if (!studentList?.length) return null;
  return (
    <>
      {studentList.map((student, index) => (
        <StudentTable
          key={student?._id || index}
          student={student}
          isAutoEval={isAutoEval}
        />
      ))}
    </>
  );
};

export default StudentTableProps;
